// src/App.js
// Main entry point for the React application.
// This file sets up the root component and renders the main visualizer UI.

import { useState, useEffect } from "react";
import TextEmbeddingVisualizer from "./components/TextEmbeddingVisualizer";

/**
 * Parse a session ID from the current URL hash.
 * Matches patterns like `#/session/<id>`.
 * @returns {string|null}
 */
function parseSessionIdFromHash() {
  const match = window.location.hash.match(/^#\/session\/(.+)$/);
  return match ? match[1] : null;
}

/**
 * App component - root of the React component tree.
 * Supports hash-based routing: if the hash is `#/session/:id`,
 * the session ID is passed to TextEmbeddingVisualizer for pre-population.
 */
function App() {
  const [sessionId, setSessionId] = useState(parseSessionIdFromHash);

  useEffect(() => {
    function onHashChange() {
      setSessionId(parseSessionIdFromHash());
    }
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return <TextEmbeddingVisualizer tokenizer={null} sessionId={sessionId} />;
}

export default App;
